export const projectClassificationSchema = {
	schema: {
		title: 'project classification schema',
		version: 0,
		primaryKey: 'code',
		type: 'object',
		properties: {
			code: { type: 'string', maxLength: 250 },
			name: { type: 'string' },
			image: { type: 'string' },
		},
		required: ['code', 'name', 'image'],
	},
};
